import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { loginEmailcheck } from "../api/accountAction";
// import { userInfoMethod } from "../slice/userSlice";
import preloader from "../../assets/loader/pre_loader.gif";

const AzureAuth = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigateFn = useNavigate();
  const [messagestatus, setmessageStatus] = useState(false);
  const [errormessagestatus, setErrorMessageStatus] = useState(false);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setLoader(true);
    const urlParams = new URLSearchParams(location.search);
    const hashParams = location.hash.substring(1);
    const result = hashParams.split("&");
    const idToken = result
      .find((param) => param.startsWith("id_token="))
      .split("=")[1];
    //
    const decodedToken = jwtDecode(idToken);
    //
    localStorage.setItem("_token", idToken);
    // Access the payload data from the decoded token
    const user_id = decodedToken["cognito:username"];
    const exp_time = decodedToken["exp"];
    const email = decodedToken.email;
    const input = {
      user_id: email,
    };

    dispatch(loginEmailcheck(input))
      .unwrap()
      .then(({ data }) => {
        setErrorMessageStatus(false);
        const encodedString = btoa(
          JSON.parse(data.aivolvex_control_plane)[0].company_name
        );
        const encodedEmail = btoa(email);
        const normalencodedString = btoa("azure");

        localStorage.setItem(
          "AIVolveXIdentityServiceProvider.com",
          encodedString
        );
        localStorage.setItem(
          "AIVolveXIdentityServiceProvider.logtype",
          normalencodedString
        );
        localStorage.setItem(
          "AIVolveXIdentityServiceProvider.auth",
          encodedEmail
        );
        // dispatch(welcomeEmail({ email }))
        //   .unwrap()
        //   .then((data) => {
        //     window.location.href = "/calls";
        //   })
        //   .catch((err) => {

        //
        //     message.error(err.message);
        //   });

        window.location.href = "/calls";
      })
      .catch((err) => {
        setErrorMessageStatus(true);
        // console.log(err);
      });
  }, [location]);

  // const ssoAccountLogout = async () => {
  //   await msalInstance.logoutPopup();
  // };

  return (
    <>
      {loader ? (
        <>
          <div className="aivolvex-loader">
            <img src={preloader} width="30%" />
          </div>
        </>
      ) : (
        <>
          {errormessagestatus && (
            <div className="azure-error-message">
              <div className="azure-error-message-centent">
                Oops! Something went wrong. Please contact our support team for
                assistance.
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AzureAuth;
